// extracted by mini-css-extract-plugin
export default {"hidden":"hiddenBlock_hidden__gY7Jj","hiddenBadge":"hiddenBlock_hiddenBadge__pRo4s","frame":"hiddenBlock_frame__51bMH"};